export const ItemTypes = {
  img: 'img',
  pdf: 'pdf',
  video: 'video'
};


// WEBPACK FOOTER //
// ./src/commonJS/constants.js